import apiClient from '../apiClient';

export const updateUserSettings = async (payload) => {
  const response = await apiClient.patch('/users/me/settings', payload ?? {});
  return response?.data ?? null;
};

export const fetchUserSettings = async () => {
  const response = await apiClient.get('/users/me/settings');
  return response?.data ?? null;
};

export default {
  updateUserSettings,
  fetchUserSettings,
};
